import React,  { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './app/store'
import { Provider } from 'react-redux'
import SuspenseContent from './containers/SuspenseContent';
// 👇 1. Import Google Provider
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Suspense fallback={<SuspenseContent />}>
        <HelmetProvider>
            <Provider store={store}>
                {/* 👇 2. Wrap App with GoogleOAuthProvider */}
                <GoogleOAuthProvider clientId="879991689698-ds5t0rnpsabo6segkmrpqubhn97antgu.apps.googleusercontent.com"> {/* PUT GOOGLE CLIENT ID HERE */}
                    <App />
                </GoogleOAuthProvider>
            </Provider>
        </HelmetProvider>
    </Suspense>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();